import { Button, Form, Input, message } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { FormCard } from '@/components/PageLayout';
import { useChangePassword } from '@/hooks/useAuthQueries';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

const CardWrapper = styled.div`
  max-width: 480px;
  width: 100%;
`;

const CardTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 20px;
  color: #1a1a1a;
`;

export const SecuritySettingsPage: React.FC = () => {
  const [form] = Form.useForm();
  const { mutate: changePassword, isPending } = useChangePassword();

  const handleFinish = (values: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }) => {
    changePassword(values, {
      onSuccess: () => {
        message.success('Пароль успішно змінено');
        form.resetFields();
      },
      onError: (error) => {
        message.error(error.message);
      },
    });
  };

  return (
    <PageWrapper>
      <CardWrapper>
        <FormCard>
          <CardTitle>Зміна пароля</CardTitle>
          <Form form={form} layout="vertical" onFinish={handleFinish}>
            <Form.Item
              name="currentPassword"
              label="Поточний пароль"
              rules={[{ required: true, message: 'Будь ласка, введіть поточний пароль' }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="newPassword"
              label="Новий пароль"
              rules={[
                { required: true, message: 'Будь ласка, введіть новий пароль' },
                { min: 6, message: 'Пароль має містити щонайменше 6 символів' },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Підтвердіть новий пароль"
              dependencies={['newPassword']}
              rules={[
                { required: true, message: 'Будь ласка, підтвердіть новий пароль' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Паролі не збігаються'));
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isPending}>
                Змінити пароль
              </Button>
            </Form.Item>
          </Form>
        </FormCard>
      </CardWrapper>
    </PageWrapper>
  );
};
